import { useEffect } from "react";

import castArray from "lodash/fp/castArray";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import head from "lodash/fp/head";
import includes from "lodash/fp/includes";
import isNil from "lodash/fp/isNil";
import map from "lodash/fp/map";

export default function useDefaultValuesOnFirstRender({
  options,
  defaultValueToSetOnRender,
  onChange,
  selectedValue,
}) {
  const filteredOptionValues = map(get("value"))(options);

  const filteredDefaultValueToSetOnRender = flow(
    castArray,
    filter((valueToSet) => includes(valueToSet)(filteredOptionValues)),
    head
  )(defaultValueToSetOnRender);

  useEffect(() => {
    if (filteredDefaultValueToSetOnRender && isNil(selectedValue)) {
      onChange(filteredDefaultValueToSetOnRender);
    }
  }, []);
}
